import React from 'react';
import './styles/App.css';
import TopBar from './components/TopBar';
import Sidebar from './components/SideBar';
import Content from './components/Content';

import { Web3Provider } from './components/Web3Context';

function App() {
  return (
    <>
      <Web3Provider>
        <TopBar />
        <div style={{ display: 'flex' }}>
          <Sidebar/>
          <div style={{ flex: 1, backgroundColor: '#e9ecef', minHeight: '100vh' }}>
            <Content />
          </div>
        </div>
      </Web3Provider>
    </>
  );
}

export default App;
